import { OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppInjector } from '@shared/services/app-injector.service';
import { AccountService } from '../../account/account.service';
import { ProjectService } from '../project.service';
import { BaseComponent } from '@shared/components/base.component';
import { User } from '@shared/models/user/user.model';
import * as moment from 'moment';

@Directive()
export class BaseProjectComponent extends BaseComponent implements OnDestroy {
  accountService: AccountService;
  someSubscriptions: Subscription = new Subscription();
  loading: boolean = false;
  projectService: ProjectService;

  constructor() {
    super();
    const injector = AppInjector.getInjector();
    this.accountService = injector.get(AccountService);
    this.projectService = injector.get(ProjectService);
  }

  checkUserHaveAllInfo(user: User) {
    return (
      !user.name ||
      !user.surname
    );
  }

  checkUserHaveAllYear(user: User) {
    const res = moment().diff(moment(user.birthday, this.Config.DATE_FORMAT_BACKEND), 'years');
    return res < 18;
  }

  ngOnDestroy() {
    this.someSubscriptions.unsubscribe();
  }
}
